import { toast } from "react-toastify";

const fnOpenToast = (alertMsg, alertSeverity) => {
    switch (alertSeverity) {
        case "error":
            toast.error(alertMsg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            break;
        case "success":
            toast.success(alertMsg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
            break;
    }
};
export default fnOpenToast;
